export const baseUrl = "https://api.selenacenter.com";
// export const baseUrl = "http://192.168.10.112:8000";
